<style lang="scss" type="text/scss">
  .person {
    margin: 2px 4px;
    background: #fff;
    border-radius: 4px;
    padding: 8px;
    display:inline-block;
    font-size: 12px;
    line-height: 1;
    color: #424242;
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06); 
  }

  .person.primary {
    background: #424242;
    color: #fff;
  }
</style>

<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';

  export let household;

  function getHouseholdLink() {
    return `/households/view/${household.id}`;
  }
</script>

<Card hover>
  <Link href={getHouseholdLink()}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9">
        <h3>
          {household.primary.person.lastName} Household
        </h3>
      </div>
    </div>
  </div>
  <hr />
  <div class="stat end">
    <div class="grid-x">
      <div class="cell small-12 medium-12">
        <h4>{household.people.length} People</h4>
        {#each household.people as person}
          <span class:primary={person.primary} class="person">
            {person.firstName} {person.lastName}
          </span>
        {/each}
      </div>
    </div>
  </div>
  </Link>
</Card>


